const USD_FORMATTERS = new Map<number, Intl.NumberFormat>();

export function formatUsdCost(value: number | string | null | undefined): string {
  const amount = parseCost(value);
  if (amount === null) return "—";

  const abs = Math.abs(amount);
  const fractionDigits = abs > 0 && abs < 0.01 ? 6 : abs < 1 ? 3 : 2;
  return formatter(fractionDigits).format(amount);
}

function parseCost(value: number | string | null | undefined): number | null {
  if (value === null || value === undefined || value === "") return null;
  const amount = typeof value === "number" ? value : Number.parseFloat(value);
  return Number.isFinite(amount) ? amount : null;
}

function formatter(fractionDigits: number): Intl.NumberFormat {
  const cached = USD_FORMATTERS.get(fractionDigits);
  if (cached) return cached;
  const created = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  });
  USD_FORMATTERS.set(fractionDigits, created);
  return created;
}